
interface FormData {
  [key: string]: any;
}

const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'video/mp4', 'video/quicktime'];

export const validateBusinessForm = (formData: FormData) => {
  const errors: Record<string, string> = {};
  
  console.log('Validation Started', { formData });
  
  // Required fields validation with detailed logging
  const requiredFields = ['name', 'description', 'city', 'category'];
  requiredFields.forEach(field => {
    if (!formData[field] || (typeof formData[field] === 'string' && formData[field].trim() === '')) {
      console.warn(`Missing required field: ${field}`);
      errors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    }
  });
  
  // Extended URL validation
  const validateUrl = (url: string) => {
    if (!url) return true;
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$','i' // fragment locator
    );
    return urlPattern.test(url);
  };
  
  // Validate URLs if provided
  ['website', 'facebook', 'instagram', 'tiktok'].forEach(field => {
    if (formData[field] && !validateUrl(formData[field])) {
      console.warn(`Invalid URL for ${field}`);
      errors[field] = `Please enter a valid ${field} URL`;
    }
  });
  
  // Email validation
  if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    console.warn('Invalid email format');
    errors.email = "Please enter a valid email address";
  }
  
  // Media files validation
  if (formData.mediaFiles && formData.mediaFiles.length > 0) {
    // Check total number of files
    if (formData.mediaFiles.length > 10) {
      console.warn('Too many media files');
      errors.mediaFiles = "Maximum 10 files allowed";
    }
    
    // Check each file
    formData.mediaFiles.forEach((file: File, index: number) => {
      if (file.size > MAX_FILE_SIZE) {
        console.warn(`File ${index} exceeds size limit`);
        errors.mediaFiles = `${file.name} exceeds 5MB limit`;
      }
      
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        console.warn(`Unsupported file type for file ${index}`);
        errors.mediaFiles = `${file.name} is not an allowed file type`;
      }
    });
  }
  
  console.log('Validation Completed', { 
    isValid: Object.keys(errors).length === 0,
    errors 
  });
  
  return {
    errors,
    isValid: Object.keys(errors).length === 0
  };
};
